import React, { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';

import { useQueryParams } from '../_hooks';
import { usePostMessageApi } from '../_hooks/usePostMessageApi';
import { Button, Icon } from '../_shared';
import { examinationActions } from '../_store/actions';
import { translations } from '../_translations';
import { Language } from '../_translations/Language';
import { PostmessageExternalSender } from '../_utils';

import './startscreen.scss';

const StartScreen: FC = () => {
  console.log('StartScreen rendered');
  const { language } = useQueryParams<{ language: string }>();
  const { keepAlive } = usePostMessageApi();
  const dispatch = useDispatch();
  const postmessageExternalSender = new PostmessageExternalSender();
  const locale = language === 'fr' ? 'fr' : 'nl';

  useEffect(() => {
    Language.setLocale(locale);
  }, [locale]);

  function startExampleQuestion(): void {
    keepAlive();
    dispatch(new examinationActions.StartExampleQuestion());
  }

  function openUrl(url: string): void {
    postmessageExternalSender.openUrl(url);
  }

  return (
    <>
      <Helmet>
        <meta content="noindex" name="robots" />
      </Helmet>
      <div className="startscreen-wrapper">
        <div className="literals-wrapper">
        <ul>
          {['ONE', 'TWO', 'THREE', 'FOUR'].map((value: string) => (
            <li key={value}>{translations.getLabel(`START.LITERAL_${value}`)}</li>
          ))}
        </ul>

        <div className="cookie">
          <p className="cookie__text">
            {translations.getLabel('LOGIN.COOKIE')}
            <span onClick={() => openUrl(`https://www.vab.be/${locale}/over-vab/privacy`)}>
              {translations.getLabel('LOGIN.ICI')}
            </span>
            {locale === 'nl' && <span>{translations.getLabel('LOGIN.CONSULT')}</span>}
          </p>
        </div>
      </div>

      <Button onClick={startExampleQuestion} theme="primary">
          <p>{translations.getLabel('BUTTONS.START_EXAM')}</p>
          <Icon className="chrevron" name="SvgChevronRight" />
        </Button>
      </div>
    </>
  );
};

export default StartScreen;
